'use strict';

/**
 * @ngdoc service
 * @name vTvPackageServices.TvPackageCartFactory
 * @description returns a {@link vTvPackageServices.TvPackageCart TvPackageCart} that contains channels
 */

angular.module('v-tv-package-services').factory('TvPackageCartFactory', function TvPackageCartFactory($rootScope, $rootElement) {

    /**
     * @ngdoc service
     * @name vTvPackageServices.TvPackageCart
     * @description returns a TvPackageCart that contains channels and blocks
     */

    return function TvPackageCart(cartKey) {
        var _this = this;

        /**
         * @typedef {Object} channelSelectionItem
         * @property {number} categoryId the id of the category where the channel belongs to
         * @property {array<number>} channelIds an array of channel ids and/or multiplex ids
         */

        /**
         * @typedef {Object} cartData
         * @property {array<vTvPackageServices.TvPackageCart.ChannelSelectionItem>} selectedChannels list of selected channels
         * @property {array} selectedBlockIds an array of selected blocks ids
         */

        /* @type cartData */
        var cartData = null;
        var isInitialized = false;
        var cartElementValidity = void 0;

        var isCartDisabled = true;

        var selectionProcessedListener = $rootScope.$on('TvPackageSelectionStateService.selectionProcessed', function (event, cartState) {
            return _this.setElementsValidity(cartState);
        });

        /**
         * @ngdoc method
         * @name vTvPackageServices.TvPackageCartFactory#setElementsValidity
         * @methodOf vTvPackageServices.TvPackageCartFactory
         * @param {object} cartState The state
         * @returns {object} cartElements with validity flags based on cartState (response from process-selection api)
         */
        this.setElementsValidity = function (cartState) {
            cartElementValidity = {};

            for (var i = 0, lengthCategories = cartState.selection.channelsByCategory.length; i < lengthCategories; i++) {
                var channelsCategory = cartState.selection.channelsByCategory[i];

                for (var j = 0, lengthElements = channelsCategory.displayElements.length; j < lengthElements; j++) {
                    //cartElementValidity[channelsCategory.displayElements[j].id] = channelsCategory.displayElements[j].id === '2380049' ? false : channelsCategory.displayElements[j].isValid;
                    if (channelsCategory.displayElements[j]) {
                        cartElementValidity[channelsCategory.displayElements[j].id] = channelsCategory.displayElements[j].isValid;
                    }
                }
            }

            return cartElementValidity;
        };

        /**
         * @ngdoc method
         * @name vTvPackageServices.TvPackageCartFactory#getIsDisabled
         * @methodOf vTvPackageServices.TvPackageCartFactory
         * @returns {boolean} true if the cart is disabled (will still hold on current elements, but won't apply
         * changes nor return it's content)
         */

        this.getIsDisabled = function () {
            return isCartDisabled;
        };

        /**
         * @ngdoc method
         * @name vTvPackageServices.TvPackageCartFactory#setIsDisabled
         * @methodOf vTvPackageServices.TvPackageCartFactory
         * @param {boolean} isDisabled True if the cart needs to be disabled. When disabled, it will still hold on
         * current elements, but won't apply changes nor return it's content
         */

        this.setIsDisabled = function (isDisabled) {
            isCartDisabled = isDisabled;
        };

        $rootElement.on('$destroy', selectionProcessedListener);

        this.isInitialized = function () {
            return isInitialized;
        };

        /**
         * @ngdoc method
         * @name vTvPackageServices.TvPackageCart#getCartData
         * @methodOf vTvPackageServices.TvPackageCart
         * @returns {vTvPackageServices.TvPackageCart.CartData} the cart content
         * ```
         {
          "selectedChannels":[
            {
              "categoryId" : 235,
              "channelIds":[22, 33, 44]
            }
          ],
          "selectedBlockIds": [23,44,55]
        }
         * ```
         *
         */
        this.getCartData = function () {

            if (_this.getIsDisabled()) {
                return null;
            }

            return cartData;
        };

        /**
         * @ngdoc method
         * @name vTvPackageServices.TvPackageCart#setCartData
         * @methodOf vTvPackageServices.TvPackageCart
         * @param {vTvPackageServices.TvPackageCart.CartData} data the cart content
         * @returns {cartData} the cart's content
         */

        this.setCartData = function (data) {
            if (!_this.getIsDisabled()) {
                isInitialized = true;
                cartData = data;

                return cartData;
            }
            return null;
        };

        /**
         * @ngdoc method
         * @name vTvPackageServices.TvPackageCart#add
         * @methodOf vTvPackageServices.TvPackageCart
         * @param {string|number} mplexId the id of the multiplex element to add to the cart
         */

        this.add = function (mplexId) {
            if (!_this.getIsDisabled()) {
                cartData = cartData !== null ? cartData : {};
                cartData.selectedChannels = cartData.selectedChannels || [];
                cartData.selectedChannels.push(mplexId);
                cartElementValidity[mplexId] = true;
            }
        };

        /**
         * @ngdoc method
         * @name vTvPackageServices.TvPackageCart#has
         * @methodOf vTvPackageServices.TvPackageCart
         * @param {string|number} mplexId The id of the element to find in the cart
         * @returns {boolean} true if the cart is enabled and the element is in the cart.
         */

        this.has = function (mplexId) {
            return !_this.getIsDisabled() && cartData && cartData.selectedChannels && cartData.selectedChannels.indexOf(mplexId) !== -1;
        };

        /**
         * @ngdoc method
         * @name vTvPackageServices.TvPackageCart#isValid
         * @methodOf vTvPackageServices.TvPackageCart
         * @param {string|number} mplexId The id of the element to find in the cart
         * @returns {boolean} true if the cart is enabled and the element is in the cart and valid.
         */

        this.isValid = function (mplexId) {
            return !_this.getIsDisabled() && cartElementValidity && mplexId in cartElementValidity ? !!cartElementValidity[mplexId] : true;
        };

        /**
         * @ngdoc method
         * @name vTvPackageServices.TvPackageCart#remove
         * @methodOf vTvPackageServices.TvPackageCart
         * @param {string|number} mplexId The id of the element to remove from the cart
         */

        this.remove = function (mplexId) {
            if (cartData.selectedChannels) {
                var mplexIndex = cartData.selectedChannels.indexOf(mplexId);

                if (mplexIndex !== -1) {
                    cartData.selectedChannels.splice(mplexIndex, 1);
                    cartElementValidity[mplexId] = false;
                }

                if (!cartData.selectedChannels.length) {
                    cartData = null;
                }
            }
        };

        /**
         * @ngdoc method
         * @name vTvPackageServices.TvPackageCart#getKey
         * @methodOf vTvPackageServices.TvPackageCart
         * @returns {string} the cart content
         */
        this.getKey = function () {
            return cartKey;
        };

        Object.seal(this);
    };
});